import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import InputText from 'components/TextInput/InputText';
import Button from 'components/Button/Button';
import { useAppDispatch, useAppSelector } from 'helpers/redux';

import { RootState } from 'app/store';
import { UserCredential } from 'features/login/models';
import SelectInput from 'components/SelectInput/SelectInput';
import BasicSelectInput from 'components/SelectInput/BasicSelectInput';
import { mreTypeOptions } from 'features/worksheet/process/mre/constants';
import { Option } from 'components/SelectInput/BasicSelectInput';
import { text } from 'stream/consumers';
import { SingleValue } from 'react-select';
import { MRETypeEnum } from 'features/worksheet/process/mre/models';
import { yupResolver } from '@hookform/resolvers/yup/dist/yup';

import * as yup from 'yup';
import { addMrePoleLog } from 'features/basic/pole/pole.reducer';

interface MrePoleLogInput {
    poleId: Option;
    PoleMREStatus: string;
    poleType: string;
    // other fields as needed
}

enum PoleMREEnum {
    MRE,
    QC,
}

export const MREPoleStatusOptions: Option[] = [
    { value: PoleMREEnum.MRE.toString(), label: 'MRE', text: 'MRE' },
    { value: PoleMREEnum.QC.toString(), label: 'QC', text: 'QC' },
];

const AddMREPoleLogForm = () => {
    const poleMREByJobForLog = useAppSelector(
        (state: RootState) => state.pole.poleMREByJobForLog ?? []
    );
    const isLoading = useAppSelector(
        (state: RootState) => state.pole.isLoading ?? false
    );
    const user = useAppSelector(
        (state: RootState) => state.user.userAuth ?? ({} as UserCredential)
    );

    const dispatch = useAppDispatch();
    const {
        register,
        handleSubmit,
        formState: { errors },
        watch,
        setValue,
        reset,
    } = useForm<MrePoleLogInput>({
        defaultValues: {
            PoleMREStatus: '0',
            poleType: '0',
        },
        resolver: yupResolver(
            yup.object().shape({
                poleId: yup.object().required('Pole is required'),
                PoleMREStatus: yup
                    .string()
                    .required('Pole MRE Status is required'),
                poleType: yup.string().required('MRE Type is required'),
            })
        ),
    });

    const onSubmit = (data: MrePoleLogInput) => {
        if (!user || !user.user_id) {
            alert('User is not authenticated');
            return;
        }
        const _input = {
            userId: user.user_id,
            poleId: data.poleId?.value ?? '',
            PoleStatus: parseInt(data.PoleMREStatus) as PoleMREEnum,
            poleType: parseInt(data.poleType) as MRETypeEnum,
        };

        dispatch(addMrePoleLog(_input));
        // dispatch(changeOvertimeStatus(_input));
    };

    return (
        <div className="p-2 md:p-6 pt-2 md:pt-2 bg-white dark:border-gray-700 dark:bg-gray-800 rounded-2xl">
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="mt-2">
                    <SelectInput
                        key={`my_unique_select_key__pole_type`}
                        options={poleMREByJobForLog?.map((item, index) => ({
                            value: item.id,
                            label: item.no + item.index,
                            text: item.no + item.index,
                        }))}
                        isLoading={isLoading}
                        label="Select Pole"
                        onChange={(val: SingleValue<Option>) =>
                            setValue('poleId', val ?? ({} as Option))
                        }
                        message={errors.poleId?.message}
                        // defaultInputValue={initialValue}

                        value={watch('poleId')}
                        menuPosition="fixed"
                        menuPlacement="auto"
                    />
                </div>
                <BasicSelectInput
                    label="Pole MRE Status"
                    options={MREPoleStatusOptions}
                    message={errors.poleType?.message}
                    {...register('PoleMREStatus')}
                />
                <BasicSelectInput
                    label="MRE Type"
                    options={mreTypeOptions}
                    message={errors.poleType?.message}
                    {...register('poleType')}
                />
                <div className="pt-2 pb-2">
                    <Button color="success" type="submit" title="Submit" />
                </div>
            </form>
        </div>
    );
};

export interface AddMREPoleLogFormProps {}

export default AddMREPoleLogForm;
